import { render } from "./attendance-policies.vue?vue&type=template&id=a49c5d44&scoped=true"
import script from "./attendance-policies.vue?vue&type=script&lang=js"
export * from "./attendance-policies.vue?vue&type=script&lang=js"

import "./attendance-policies.vue?vue&type=style&index=0&id=a49c5d44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a49c5d44"]])

export default __exports__